import { Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    EXTERNAL_CHECKBOX_FILTER_LABELS,
    EXTERNAL_RANGE_FILTER_LABELS,
    ONE_TO_SIX_OPTIONS_MAX, ONE_TO_SIX_OPTIONS_MIN,
} from 'constants/filterOptions';
import Box from '@mui/material/Box';
import React from 'react';
import CheckboxFilter from 'components/commons/CheckboxFilter';
import TextFieldFilter from 'components/TextFieldFilter';
import { isNZLocale } from 'lib/PropertyUtils';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import { validateCharacters, validateDecimalPlaces, validateMaxLength } from 'lib/Validations';
import { EXTERNAL_TEXTBOX_LABEL } from 'constants/advancedFilters';

function ExternalFilter(props) {
    const validateInput = (input) => {
        return (
            validateCharacters(input) ||
            validateMaxLength(input) ||
            validateDecimalPlaces(input)
        );
    };

    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>External</Typography>
            {
                !isNZLocale() && (
                    <>
                        <Grid container>
                            {
                                Object.keys(EXTERNAL_CHECKBOX_FILTER_LABELS).map((value) => {
                                    return (
                                        <Grid item size={4} key={value}>
                                            <CheckboxFilter
                                                value={EXTERNAL_CHECKBOX_FILTER_LABELS[value]}
                                                comparableType={props.comparableType}
                                                attrName={value}
                                            />
                                        </Grid>
                                    );
                                })
                            }

                        </Grid>
                        <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
                        <Grid container spacing={3}>
                            {
                                Object.keys(EXTERNAL_RANGE_FILTER_LABELS).map((value) => {
                                    return (
                                        <Grid item size={6} key={value}>
                                            <RangeAutocomplete
                                                comparableType={props.comparableType}
                                                attrName={value}
                                                label={EXTERNAL_RANGE_FILTER_LABELS[value]}
                                                subLabel="Select an option or manually enter a value"
                                                minOptions={ONE_TO_SIX_OPTIONS_MIN}
                                                maxOptions={ONE_TO_SIX_OPTIONS_MAX}
                                                isDropdown={false}
                                                validateInput={validateInput}
                                            />
                                        </Grid>
                                    );
                                })
                            }
                        </Grid>
                        <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
                    </>
                )
            }
            <Grid container spacing={3}>
                {
                    Object.keys(EXTERNAL_TEXTBOX_LABEL).map((value) => {
                        return (
                            <Grid item size={6} key={value}>
                                <TextFieldFilter
                                    title={EXTERNAL_TEXTBOX_LABEL[value]}
                                    label="Enter in materials"
                                    comparableType={props.comparableType}
                                    attrName={value}
                                    maxLength={60}
                                    width="100%"
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
        </Box>
    );
}

export default React.memo(ExternalFilter);